let animationFrameId = null
let resizeFrameId = null
let lastTimestamp = 0
let isPaused = false
let pauseHandlersBound = false

const bandInstances = []
const SPEED_FACTORS = [0.72, 1.04, 1.38]

function setupPauseHandlers() {
	const bandsRoot = document.querySelector('[data-regionen-bands]')

	if (!bandsRoot || pauseHandlersBound) {
		return
	}

	bandsRoot.addEventListener('mouseover', (event) => {
		if (event.target.closest('.regionen-band-item')) {
			isPaused = true
		}
	})

	bandsRoot.addEventListener('mouseleave', () => {
		isPaused = false
	})

	bandsRoot.addEventListener('focusin', (event) => {
		if (event.target.closest('.regionen-band-item')) {
			isPaused = true
		}
	})

	bandsRoot.addEventListener('focusout', () => {
		const activeElement = document.activeElement
		if (!activeElement || !bandsRoot.contains(activeElement) || !activeElement.closest('.regionen-band-item')) {
			isPaused = false
		}
	})

	pauseHandlersBound = true
}

function applyTransform(instance) {
	instance.band.style.transform = `translate3d(${instance.offset}px, 0, 0)`
}

function normalizeOffset(instance) {
	if (instance.direction === 'left') {
		while (instance.offset <= -instance.segmentWidth) {
			instance.offset += instance.segmentWidth
		}
	} else {
		while (instance.offset >= 0) {
			instance.offset -= instance.segmentWidth
		}
	}
}

function prepareSegments(instance) {
	const viewportWidth = instance.viewport.offsetWidth
	const markup = instance.sourceMarkup

	instance.segments.forEach((segment) => {
		segment.innerHTML = markup
	})

	let safety = 0
	while (instance.segments[0].scrollWidth < viewportWidth * 1.35 && safety < 6) {
		instance.segments.forEach((segment) => {
			segment.insertAdjacentHTML('beforeend', markup)
		})
		safety += 1
	}

	instance.segmentWidth = instance.segments[0].scrollWidth
	instance.speed = Math.max(32, Math.min(72, instance.segmentWidth / 18)) * instance.speedFactor
	instance.offset = instance.direction === 'right' ? -instance.segmentWidth : 0
	applyTransform(instance)
	instance.ready = true
	instance.band.dataset.regionenBandReady = 'true'
}

function step(timestamp) {
	if (!lastTimestamp) {
		lastTimestamp = timestamp
	}

	const deltaSeconds = (timestamp - lastTimestamp) / 1000
	lastTimestamp = timestamp

	if (!isPaused) {
		bandInstances.forEach((instance) => {
			if (!instance.ready || !instance.segmentWidth) {
				return
			}

			instance.offset += (instance.direction === 'left' ? -1 : 1) * instance.speed * deltaSeconds
			normalizeOffset(instance)
			applyTransform(instance)
		})
	}

	animationFrameId = window.requestAnimationFrame(step)
}

function rebuildBands() {
	bandInstances.forEach((instance) => {
		prepareSegments(instance)
	})
	lastTimestamp = 0
}

function handleResize() {
	if (resizeFrameId) {
		window.cancelAnimationFrame(resizeFrameId)
	}

	resizeFrameId = window.requestAnimationFrame(() => {
		rebuildBands()
	})
}

export function regionenBands() {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
	const bands = Array.from(document.querySelectorAll('[data-regionen-band]'))

	if (!bands.length || bandInstances.length) {
		return
	}

	bands.forEach((band) => {
		const viewport = band.closest('.regionen-band__viewport')
		const segments = Array.from(band.querySelectorAll('.regionen-band__segment'))

		if (!viewport || segments.length < 2) {
			return
		}

		bandInstances.push({
			band,
			viewport,
			segments,
			bandIndex: Number.parseInt(band.dataset.bandIndex || '0', 10),
			direction: band.dataset.direction === 'right' ? 'right' : 'left',
			sourceMarkup: segments[0].innerHTML,
			segmentWidth: 0,
			offset: 0,
			speed: 0,
			speedFactor: SPEED_FACTORS[Number.parseInt(band.dataset.bandIndex || '0', 10)] || 1,
			ready: false,
			items: [],
		})
	})

	if (!bandInstances.length) {
		return
	}

	rebuildBands()
	window.addEventListener('resize', handleResize, { passive: true })

	// static layout only; CSS forces transform: none and no rAF loop is needed
	if (prefersReducedMotion) {
		return
	}

	setupPauseHandlers()
	animationFrameId = window.requestAnimationFrame(step)
}